<template>
  <div id="app" @mousemove="handleTime">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      lastTime: null, //最后一次移动的时间
      currentTime: null, //当前的时间
      timeOut: 12 * 60 * 60 * 1000, //设置超时时间： 12小时
    };
  },
  created() {
    this.lastTime = new Date().getTime(); // 记录第一次的时间
  },
  methods: {
    handleTime() {
      this.currentTime = new Date().getTime(); // 记录这次移动的时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        if (sessionStorage.getItem("userIdStr")) {
          sessionStorage.clear();
          this.$alert("身份验证已过期，请重新登录", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              //这里写路由（跳转到登录页）
              this.$router.replace("/");
              this.lastTime = new Date().getTime();
            },
          });
        } else {
          this.lastTime = new Date().getTime(); // 如果在10分钟内移动，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
        }
      } else {
        this.lastTime = new Date().getTime(); // 如果在10分钟内移动，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
      }
    },
  }, //如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
  destroyed() {
    //组件销毁时清除定时器
    sessionStorage.clear();
  },
};
</script>


<style>
</style>
